import script from "./ViewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewPage.vue?vue&type=script&setup=true&lang=ts"

import "./ViewPage.vue?vue&type=style&index=0&id=634ee32c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634ee32c"]])

export default __exports__